import { FragmentSerializer as JSONSerializer } from 'ember-data-model-fragments/serializer';
import { isArray } from '@ember/array';
import { isEmpty } from '@ember/utils';
import DataType from '@linc-technologies/linced-common/enums/data-type';

export default class Value extends JSONSerializer {
  normalize(typeClass, hash) {
    // Round received float values to 2dp to sidestep floating point rounding errors.
    if (!isEmpty(hash.valueFloat)) {
      hash.valueFloat = hash.valueFloat.toFixed(2);
    }

    // Handle null arrays in ValueList/ValueValueList.
    switch (hash.datatype) {
      case DataType.LIST:
        if (!isArray(hash.valueList)) {
          hash.valueList = [];
        }
        break;
      case DataType.VALUE_LIST:
        if (!isArray(hash.valueValueList)) {
          hash.valueValueList = [];
        }
        break;
    }

    return super.normalize(...arguments);
  }
}
